import { ApiResponse, ApisauceInstance, CancelToken } from 'apisauce'
import { handleResponse } from '../handleResponse'

export const ReportsApi = {
  apisauce: {} as ApisauceInstance,

  getCancelToken: () => {
    return CancelToken.source()
  },

  /**
   * List all custom reports
   */
  getAllCustomReports: async () => {
    const response: ApiResponse<any> = await ReportsApi.apisauce.get(`/views/custom/`)
    return handleResponse(response)
  },

  /**
   * Get knowledge gain base stats
   */
  getKowledgeGainReport: async (
    start: string,
    end: string,
    user_status?: string,
    cancelToken?: any,
  ) => {
    const urlQuery = new URLSearchParams({
      start_datetime: start,
      end_datetime: end,
      user_status: user_status || 'all',
    })
    const response: ApiResponse<any> = await ReportsApi.apisauce.get(
      `/reports/knowledge_gain/?${urlQuery.toString()}`,
      {},
      { cancelToken },
    )
    return handleResponse(response)
  },

  /**
   * Get knowledge gain stats history
   */
  getKnowledgeGainHistory: async (
    start: string,
    end: string,
    user_status?: string,
    cancelToken?: any,
  ) => {
    const urlQuery = new URLSearchParams({
      start_datetime: start,
      end_datetime: end,
      user_status: user_status || 'all',
    })

    const response: ApiResponse<any> = await ReportsApi.apisauce.get(
      `/reports/knowledge_gain_history/?${urlQuery.toString()}`,
      {},
      { cancelToken },
    )
    return handleResponse(response)
  },
}
